var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('splash'):_vm._e()],1),_c('portal-target',{attrs:{"name":"sidebar-outlet"}}),_c('navigationbar'),_c('div',{staticClass:"flex-grow-1"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }